import { Icon } from './Icon'
import { linkWhatsApp } from '../config'

export function WhatsAppFloat({ visivel }: { visivel: boolean }) {
  return (
    <a
      className={`wa-float${visivel ? ' is-visible' : ''}`}
      href={linkWhatsApp()}
      aria-label="Falar no WhatsApp"
    >
      <Icon name="wa" />
    </a>
  )
}
